import React from 'react'
import { Stack, Typography } from '@mui/material'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'

import { INTERAX_COLORS, INTERAX_TYPOGRAPHY } from '../../../../constants/colors'
import { COMPONENT_DIMENSIONS } from '../../../../constants/layout'

const WARNING_ICON_SIZE_PX = COMPONENT_DIMENSIONS.ICON_MD
const WARNING_RADIUS_PX = 10

interface LeaderLossWarningProps {
  title?: string
  body: string
  testId: string
}

/** Says what is lost for good when a leader stops being one, shown before a role change or a removal. */
export const LeaderLossWarning: React.FC<LeaderLossWarningProps> = ({ title, body, testId }) => {
  const hasTitle = !!title

  return (
    <Stack
      direction="row"
      spacing={1.5}
      role="alert"
      data-testid={testId}
      sx={{
        p: { xs: 1.5, sm: 2, md: 2 },
        borderRadius: `${WARNING_RADIUS_PX}px`,
        backgroundColor: INTERAX_COLORS.redErrorBackground,
        border: `1px solid ${INTERAX_COLORS.redError}`
      }}
    >
      <ExclamationTriangleIcon
        aria-hidden
        style={{
          width: WARNING_ICON_SIZE_PX,
          height: WARNING_ICON_SIZE_PX,
          flexShrink: 0,
          color: INTERAX_COLORS.redError
        }}
      />
      <Stack spacing={0.5}>
        {hasTitle && (
          <Typography sx={{ ...INTERAX_TYPOGRAPHY.body3, fontWeight: 600, color: INTERAX_COLORS.white }}>
            {title}
          </Typography>
        )}
        <Typography sx={{ ...INTERAX_TYPOGRAPHY.body3, color: INTERAX_COLORS.white70 }}>{body}</Typography>
      </Stack>
    </Stack>
  )
}
